export default __webpack_public_path__ + "static/media/stethoscope.545ca2ca.jpg";